module.exports = __webpack_public_path__ + "static/media/pic9.dd0dcc6d.jpg";